export const stateColors = {
  PENDING_DR_REVIEW: 'lightgray',
  PENDING_ADMIN_REVIEW: 'lightblue',
  PENDING_FINANCE_REVIEW: 'lightyellow',
  APPROVED: 'lightgreen',
  DISAPPROVED: '#ffcccb'
};
export const images = {
  dr_prescription: 'Prescriptions',
  medical_bill: 'Bills',
  analysis_rays_request: 'Reports'
};
